import { jsx as _jsx } from "react/jsx-runtime";
import * as Ant from "antd";
import { ApolloError, useMutation } from "@apollo/client";
import { useTranslate } from "@bluelibs/x-ui";
import { SmileOutlined } from "@ant-design/icons";
import { ApproveTransaction } from "@bundles/UIAppBundle/mutations/ApproveTransaction";
import { useState } from "react";
const TransactionApprovalButton = ({ approved, transactionId }) => {
    const t = useTranslate();
    const [approvedStatus, setApprovedStatus] = useState(approved);
    const [approveTransaction] = useMutation(ApproveTransaction);
    const onApprove = () => {
        approveTransaction({
            variables: {
                input: { transactionId: transactionId },
            },
        })
            .then(() => {
            Ant.notification.success({
                message: t("generics.success"),
                description: t("management.transactions.edit_confirmation"),
                icon: _jsx(SmileOutlined, {}, void 0),
            });
            setApprovedStatus(true);
        })
            .catch((err) => {
            if (err instanceof ApolloError) {
                const errMessage = err.message.toLowerCase().split(" ").join("_");
                const i18nMessage = t(`apiErrors.${errMessage}`);
                Ant.notification.warn({
                    message: i18nMessage.length > 0 ? i18nMessage : t("generics.error"),
                });
            }
            else {
                Ant.notification.warn({
                    message: t("generics.error"),
                    description: t("generics.error_message"),
                });
            }
        });
    };
    return approvedStatus ? (_jsx("p", { children: t("management.transactions.approved") }, void 0)) : (_jsx(Ant.Popconfirm, Object.assign({ title: t("management.transactions.approveTransaction"), onConfirm: onApprove, okText: t("management.transactions.yes"), cancelText: t("management.transactions.no") }, { children: _jsx(Ant.Button, { children: t("management.transactions.approve") }, void 0) }), void 0));
};
export default TransactionApprovalButton;
